import React from "react";

// 🔔 Notifications du nouveau design (tour 34), d'après Etats.html : une pastille ronde par sorte
// (✓ réussite, ! erreur ou attention, i information), le reste en CSS (NewDesignStyle, classes de
// notistack). Les erreurs restent affichées jusqu'à leur fermeture (puglins/notistack.js).
const icon = (kind, text) => (
  <span className={`nd-toast-icone nd-toast-icone--${kind}`} aria-hidden="true">
    {text}
  </span>
);

export const TOAST_ICONS = {
  success: icon("success", "✓"),
  error: icon("error", "!"),
  warning: icon("warning", "!"),
  info: icon("info", "i"),
};
